import { Spinner } from 'react-bootstrap';

/**
 * Indicador de carregamento *dentro* de um painel.
 *
 * Diferente do `Loading`, que é um overlay `position: fixed` cobrindo a tela
 * inteira, este ocupa apenas a área do próprio painel. É o que permite a
 * dashboard abrir na hora e cada bloco preencher-se à medida que a sua
 * endpoint responde, em vez de a tela ficar presa num loader único.
 */
export default function PanelLoading({ height = 180 }: { height?: number | string }) {
  return (
    <div
      style={{
        height,
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
      role="status"
      aria-live="polite"
    >
      <Spinner animation="border" variant="primary" size="sm" />
      <span className="visually-hidden">Carregando…</span>
    </div>
  );
}
